import { useContext, useEffect } from "react";

import MapContext from "../map/MapContext";

import olFullScreen from "ol/control/FullScreen";
import olMap from "ol/Map";

/**
 * Component to register the OL FullScreen control on the Map
 * using the MapContext.
 * @component
 * @example
 * <Map center={center} zoom={zoom} projection={Epsg27700}>
 *   ...
 *   <Controls>
 *     <FullScreen />
 *   </Controls>
 * </Map>
 */
const FullScreen = () => {
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};

    const control = new olFullScreen({});
    map.addControl(control);

    return () => {
      if (!map) return;
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default FullScreen;
